const ready = require("%helpers%/document-ready.js");

ready(function() {

	const $btns = $("a[href^='#']");
	const headerHeight = $(".header").outerHeight(true);

	// -- Functions BEGIN
	const addEventButtons = () => {
		$btns.on("click", function(e) {
			e.preventDefault();

			const blockKey = $(this).attr("href");
			const $block = $(blockKey);

			if ( $block.length ) {
				const blockOffset = $block.offset().top;

				$([document.documentElement, document.body]).animate({
					scrollTop: blockOffset - headerHeight + 30
				}, 1000);
			}
		});
	};
	// -- Functions END

	if ( $btns.length ) addEventButtons();
});